function simulateIncomingCall(phoneNumber: string) {
  window.dispatchEvent(
    new CustomEvent('hackathon-incoming-call', { detail: { phoneNumber } }),
  );
}

export default simulateIncomingCall;
